<template>
	<!--<sequential-entrance fromLeft>-->
	<div v-if="this.data.length>0" class="card cardptpr mb-4" @click="handleCardClick">
		<div class="card-header cardptpr p-3 pb-0 pt-0" v-if="this.title">
			<H6 :class="warning ? 'text-warning' : ''">{{this.title}}</H6>
		</div>
		<div class="card-body p-3">
			<ul class="list-group">
				<li class="list-group-item hoverable-item border-0 d-flex justify-content-between ps-1 pe-1 mb-0"
						v-for="(item, index) in this.data" :key="index" @click="handleItemClick(item)">

					<div class="d-flex flex-column">
						<span class="d-flex flex-row justify-content-end text-sm">{{prefix}} {{item[itemcol]}}</span>
					</div>

					<div class="d-flex flex-column" v-if="valuecol">
						<span class="d-flex flex-row justify-content-end text-sm">{{curr}} {{(div ? item[valuecol] / div : item[valuecol]) * 1 | formatNum}} {{unit}}</span>
					</div>

					<div class="d-flex flex-column" v-if="textvaluecol">
						<span class="d-flex flex-row justify-content-end text-sm">{{item[textvaluecol]}}</span>
					</div>

				</li>
			</ul>
		</div>
	</div>
	<!--</sequential-entrance>-->
</template>

<script>
export default{
	props:["data", "title", "itemcol", "valuecol", "textvaluecol", "warning", "url", "prefix", "curr", "unit", "div", "tab"],
	components:{
	},
    mounted(){
    },
    methods:{
        handleCardClick() {
			if (this.url) {
				window.open(this.url, "_blank");
			}
		},
		handleItemClick(item) {
			const link = `/finance/report-group?tab=${this.tab}&region=${item[this.itemcol]}&detail1=station`;
			window.open(link, "_blank");
		}
	}
}

</script>

<style>
.hoverable-item {
	cursor: pointer;
	transition: background-color 0.3s ease;
    border-radius: 4px;
}

.hoverable-item:hover {
	background-color: #f5f5f5;
}

.hoverable-item:active {
	background-color: #e0e0e0;
}
</style>
